export default "__VITE_ASSET__B00zT7L4__"